











import { defineComponent, computed, PropType } from '@vue/composition-api';
import { CreditedQuotaStatusEnum } from '@/pages/home/types';
import store from '@/store';
import { PageThemeTypeEnum } from '@/enums/pageThemeType';

/**
 * 利率说明文案，如：按综合年化利率(单利)x%-xx%
 */
export default defineComponent({
  name: 'RateRemindText',
  props: {
    creditedQuotaStatus: {
      type: Number as PropType<CreditedQuotaStatusEnum>,
      required: false,
    },
  },
  setup(props) {
    const { creditedQuotaStatus } = props;
    const rateForeText = '综合年化利率(单利)';
    const showRateExp = computed(
      () => store.state.homeStore.showRateTextExp
      && store.state.base.pageThemeType === PageThemeTypeEnum.BLUE_THEME,
    );
    const rateBackText = computed(() => {
      const { rateFloor, rateCeil } = store.state.base.businessInfoExtra?.creditInfo;
      if (showRateExp.value) {
        return `最低${rateFloor}%`;
      }

      return `${rateFloor}%-${rateCeil}%`;
    });
    /** 高优先展示的提醒文案 */
    const highPriorityText = computed(
      () => (creditedQuotaStatus === CreditedQuotaStatusEnum.USE_OUT_AMOUNT ? '按时还款·额度恢复后可借款' : ''),
    );

    return {
      highPriorityText,
      rateForeText,
      rateBackText,
      showRateExp,
    };
  },
});
